module.exports = __webpack_public_path__ + "static/media/demo-img.ca218d5f.png";